module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobileLgWrap_he"
  }, [_c('van-nav-bar', {
    staticClass: "userNavBar",
    attrs: {
      "title": "注册",
      "left-arrow": ""
    },
    on: {
      "click-left": _vm.onClickLeft
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function() {
        return [_c('van-icon', {
          attrs: {
            "name": "../../../static/images/mobile/back.png",
            "size": "18"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "loginMain_he"
  }, [_c('van-form', [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "placeholder": "请输入手机号",
      "type": "number",
      "name": "mobile",
      "clearable": "",
      "label-align": "left"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "pattern",
      "rules": [{
        pattern: _vm.pattern,
        message: '请输入8-16位字母和数字组合密码'
      }],
      "formatter": _vm.formatter,
      "clearable": "",
      "placeholder": "请输入8-16位密码,字母+数字",
      "right-icon": _vm.rightIcon,
      "type": _vm.pwdType
    },
    on: {
      "click-right-icon": _vm.changeType
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "placeholder": "请输入短信验证码",
      "type": "number",
      "name": "yzm",
      "clearable": "",
      "label-align": "left"
    },
    on: {
      "input": _vm.changColor
    },
    model: {
      value: (_vm.yzm),
      callback: function($$v) {
        _vm.yzm = $$v
      },
      expression: "yzm"
    }
  }, [_c('van-button', {
    attrs: {
      "slot": "button",
      "size": "small",
      "plain": "",
      "type": "info",
      "disabled": _vm.sendCodeBtnDisabled
    },
    on: {
      "click": _vm.sendMessage
    },
    slot: "button"
  }, [_vm._v(_vm._s(_vm.sendCodeCaption))])], 1), _vm._v(" "), _c('div', {
    class: _vm.passwordNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he',
    on: {
      "click": function($event) {
        return _vm.register()
      }
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("注册")])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "agreement"
  }, [_c('van-checkbox', {
    attrs: {
      "icon-size": ".32rem",
      "shape": "square"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_c('span', {
    on: {
      "click": _vm.goAgreement
    }
  }, [_vm._v("阅读并同意《用户使用协议》和《注册协议》")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ed310a42"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileRegister.vue
// module id = 1174
// module chunks = 41